// Unified risk vocabulary — every firm gets one of these 4 labels.
// Drives:
//   - Risk badges (RISK_META[label].badge/dot)
//   - Coloured left borders on firm rows (RISK_META[label].leftClass)
//   - Risk tab + metric card accents on the Dashboard (RISK_META[label].topClass)
//
// `Churned` is a lifecycle state, not a risk label — kept here just so badge
// rendering on the Admin page works. It never appears on the Dashboard / New /
// Old / Enterprise / Firm 360.
export const RISK_LEVELS = [
  "Active",
  "At Risk",
  "Inactive",
  "Potential Churn",
];

export const RISK_META = {
  Active: {
    key: "Active",
    label: "Active",
    topClass: "risk-top-Active",
    leftClass: "risk-left-Active",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
    color: "#10B981",
  },
  "At Risk": {
    key: "AtRisk",
    label: "At Risk",
    topClass: "risk-top-AtRisk",
    leftClass: "risk-left-AtRisk",
    badge: "bg-amber-50 text-amber-700 border-amber-200",
    dot: "bg-amber-500",
    color: "#F59E0B",
  },
  Inactive: {
    key: "Inactive",
    label: "Inactive",
    topClass: "risk-top-Inactive",
    leftClass: "risk-left-Inactive",
    badge: "bg-orange-50 text-orange-700 border-orange-200",
    dot: "bg-orange-500",
    color: "#F97316",
  },
  "Potential Churn": {
    key: "PotentialChurn",
    label: "Potential Churn",
    topClass: "risk-top-PotentialChurn",
    leftClass: "risk-left-PotentialChurn",
    badge: "bg-red-50 text-red-700 border-red-200",
    dot: "bg-red-500",
    color: "#EF4444",
  },
  Churned: {
    key: "Churned",
    label: "Churned",
    leftClass: "risk-left-Churned",
    badge: "bg-gray-100 text-gray-500 border-gray-300",
    dot: "bg-gray-400",
    color: "#6B7280",
  },
};

// Safe fallback used by RiskBadge when the value is missing — surfaces as
// neutral gray so we never crash on unexpected labels.
export const RISK_FALLBACK = {
  key: "Unknown",
  label: "—",
  badge: "bg-gray-100 text-gray-500 border-gray-200",
  dot: "bg-gray-400",
  leftClass: "",
};

export const TIER_BADGE = {
  Premium: "bg-blue-50 text-blue-700 border-blue-200",
  Enterprise: "bg-violet-50 text-violet-700 border-violet-200",
  Standard: "bg-slate-100 text-slate-700 border-slate-200",
};

export function formatLastSeen(isoDate, daysSince) {
  if (!isoDate) return "Never";
  if (daysSince === 0) return "Today";
  if (daysSince === 1) return "Yesterday";
  if (daysSince < 30) return `${daysSince} days ago`;
  if (daysSince < 365) return `${Math.floor(daysSince / 30)} months ago`;
  return `${Math.floor(daysSince / 365)}y+ ago`;
}

export function pocInitials(name) {
  if (!name) return "??";
  return name.slice(0, 2).toUpperCase();
}

const POC_COLORS = {
  Shankar: "bg-blue-100 text-blue-700",
  Onkar: "bg-emerald-100 text-emerald-700",
  Vaibhav: "bg-purple-100 text-purple-700",
  Sasikiran: "bg-amber-100 text-amber-700",
  Rajaneesh: "bg-rose-100 text-rose-700",
};

export function pocColor(name) {
  return POC_COLORS[name] || "bg-gray-100 text-gray-700";
}
